import { useModules } from '@contexts/modules-provider';
import { useOrganizations } from '@contexts/organizations-provider';
import { AppLoader } from '@shared/components/app-loader/AppLoader';
import { ErrorPage } from '@shared/components/error-pages/ErrorPage';
import * as React from 'react';
import { Navigate } from 'react-router-dom';

import { OrganizationSelectorGuardProps } from './OrganizationSelectorGuard.types';

const OrganizationSelectorGuard = React.memo(
  ({
    children,
  }: Readonly<OrganizationSelectorGuardProps>): React.ReactElement => {
    const { modules, isModulesLoading } = useModules();
    const { organizations, selectedOrganization, isOrganizationsLoading } =
      useOrganizations();

    if (isModulesLoading) {
      return <AppLoader />;
    }

    const hasManageAccess = modules?.some(m => m.name === 'Manage');
    if (!hasManageAccess) {
      return <ErrorPage type="not-found" />;
    }

    if (isOrganizationsLoading) {
      return <AppLoader />;
    }

    if (!organizations || organizations.length <= 1) {
      return <Navigate to="/app-initializer" replace />;
    }

    if (selectedOrganization) {
      return (
        <Navigate
          to={`/manage/${selectedOrganization.customerId}/home`}
          replace
        />
      );
    }

    return children;
  }
);

OrganizationSelectorGuard.displayName = 'OrganizationSelectorGuard';

export { OrganizationSelectorGuard };
